import { observer } from 'mobx-react-lite'

import EmptyImage from 'shared/images/empty_tariff.png'
import { getCleanHTML } from 'shared/lib/getCleanHTML'
import { EmptyResults } from 'shared/ui/empty-result'

import styles from './styles.module.scss'

interface Props {
  content: string | null
}

const InsuranceTariffPop = observer(({ content }: Props) => {
  const cleanedHtml = content?.replace(/\\/g, '')
  return (
    <div className={styles.container}>
      <div className={styles.wrapperList}>
        {content && (
          <div className={styles.detailWrapper}>
            <div
              className={styles.desc}
              dangerouslySetInnerHTML={{
                __html: getCleanHTML(cleanedHtml || ''),
              }}
            />
          </div>
        )}
      </div>

      {!content ? (
        <EmptyResults
          image={
            <img
              src={EmptyImage}
              alt=""
              className={styles.empty}
            />
          }
        />
      ) : null}
    </div>
  )
})

export default InsuranceTariffPop
